export const LenguageTabla = {
  decimal: "",
  emptyTable: "No se encontraron resultados",
  info: "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
  infoEmpty: "Mostrando registros del 0 al 0 de un total de 0 registros",
  infoFiltered: "(filtrado de un total de _MAX_ registros)",
  infoPostFix: "",
  thousands: ",",
  lengthMenu: "Mostrar _MENU_ registros",
  loadingRecords: "Cargando...",
  processing: "Procesando...",
  search: "Buscar:",
  zeroRecords: "No se encontraron resultados",
  paginate: {
    first: "Primero",
    last: "Último",
    next: "Siguiente",
    previous: "Anterior",
  },
  select: {
    rows: {
      1: "%d fila seleccionada",
      _: "%d filas seleccionadas",
    },
  },
  buttons: {
    selectAll: "Seleccionar todos",
    selectNone: "Quitar selección",
  },
};
